import React, {
    Children,
    Fragment,
    isValidElement,
    ReactNode,
    useContext,
    useEffect,
} from 'react';
import themeContext from '../../context/theme/themeContext';
import tableContext from './tableContext';
import TableState from './TableState';

type Props = {
    headers: ReactNode[] | ReactNode;
    children: ReactNode;
    defaultStyles?: boolean;
    numOfColumns: number;
    dataLength: number;
    className?: string;
};

const Table: React.FC<Props> = ({
    headers,
    children,
    defaultStyles = false,
    numOfColumns,
    dataLength,
    className = '',
}) => {
    const { theme } = useContext(themeContext);
    const { initialDataLength, setNumOfColumns, setDataLength, setInitialDataLength } =
        useContext(tableContext);

    useEffect(() => {
        setNumOfColumns(numOfColumns);
    }, [numOfColumns, setNumOfColumns]);

    useEffect(() => {
        if (!initialDataLength) {
            setInitialDataLength(dataLength);
        }

        setDataLength(dataLength);
    }, [initialDataLength, dataLength, setDataLength, setInitialDataLength]);

    return (
        <div className={`table-container ${theme} ${className}`}>
            <div className='table-wrapper'>
                <div
                    className='table'
                    style={{
                        gridTemplateColumns: defaultStyles
                            ? `repeat(${numOfColumns},1fr)`
                            : undefined,
                    }}
                >
                    <div className='header row'>
                        {Children.count(headers)
                            ? Children.toArray(headers).map(
                                  (header: ReactNode, index: number) =>
                                      isValidElement(header) ? (
                                          <Fragment key={index}>{header}</Fragment>
                                      ) : (
                                          <div key={index}>{header}</div>
                                      )
                              )
                            : headers}
                        <div
                            className='border'
                            style={{
                                gridColumn: `1/${numOfColumns + 1}`,
                            }}
                        />
                    </div>
                    {React.Children.toArray(children).filter(
                        (child: any) => child?.type?.displayName !== 'Pagination'
                    )}
                </div>
            </div>
            {React.Children.toArray(children).filter(
                (child: any) => child?.type?.displayName === 'Pagination'
            )}
        </div>
    );
};

const TableWrapper: React.FC<Props> = (props) => (
    <TableState>
        <Table {...props} />
    </TableState>
);

export default TableWrapper;
